import { tv } from 'tailwind-variants'

export const replyMessageBubbleVariants = tv({
  slots: {
    base: 'p-mili rounded-tl-mili rounded-tr-mili mb-mili min-w-[100%] max-w-[100%]'
  },
  variants: {
    source: {
      CLIENT: 'rounded-b-mili self-start bg-secondary-light border-l-[5px] border-success-medium',
      PRODUCT: 'rounded-b-mili self-end bg-secondary-light border-l-[5px] border-primary-medium '
    }
  }
})
